import type { Pinia } from 'pinia'
import ConnectWebSocket from '@/websocket'
import { getWebsocketUrl } from '@/websocket/utils/config'
import { createDeviceWsMessageHandler } from '@/utils/device-ws-message-handler'

const sockets = new Map<string, ConnectWebSocket>()

export function attachSdkDeviceWebSocket (pinia: Pinia, registryKey: string, urlOverride?: string): void {
  detachSdkDeviceWebSocket(registryKey)
  const url = urlOverride?.trim() ? urlOverride.trim() : getWebsocketUrl()
  if (!url) {
    console.warn('[MonitorMfeSDK] 未配置 WebSocket 地址，已跳过连接')
    return
  }
  const ws = new ConnectWebSocket(url)
  ws.registerMessageHandler(createDeviceWsMessageHandler(pinia))
  ws.initSocket()
  sockets.set(registryKey, ws)
}

export function detachSdkDeviceWebSocket (registryKey: string): void {
  sockets.get(registryKey)?.close()
  sockets.delete(registryKey)
}
